import React from 'react';
import { LineChart, Line, ResponsiveContainer, Tooltip as RechartsTooltip } from 'recharts';
import { SparkIcon } from '@spark';

/**
 * Total Requests metric card with sparkline line chart.
 */
const RequestsCard = ({ requests }) => {
    const {
        total = 0,
        changePercent = 0,
        series = [],
    } = requests || {};

    const isPositive = changePercent >= 0;

    return (
        <div className="metric-card">
            <div className="metric-card__label">Requests</div>

            <div className="metric-card__big-row">
                <span className="metric-card__big-number">
                    {total.toLocaleString()}
                </span>
                <span className="metric-card__peak">Total</span>
            </div>

            <div className="metric-card__comparison">
                <span className={`comparison-tag ${isPositive ? 'comparison-tag--positive' : 'comparison-tag--negative'}`}>
                    <SparkIcon slug={isPositive ? 'trending-up' : 'trending-down'} size="small" />
                    {Math.abs(changePercent)}% Vs Prev. hour
                </span>
            </div>

            <div className="metric-card__sparkline">
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={series} margin={{ top: 4, right: 0, left: 0, bottom: 0 }}>
                        <RechartsTooltip
                            formatter={(v) => [v.toLocaleString(), 'Requests']}
                            contentStyle={{ fontSize: 12 }}
                        />
                        <Line
                            type="monotone"
                            dataKey="count"
                            stroke="#1753FF"
                            strokeWidth={2}
                            dot={false}
                            isAnimationActive={false}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default RequestsCard;
